import React from 'react';
import { Transition } from '@headlessui/react';
import SimpleButton from '../basicComponents/SimpleButton';
import Separator from '../basicComponents/Separator';
import { HEX_ALPHA } from '../../utils/constants';
import { getText } from '../../utils/functions';
import PopUpWrapper from '../../containers/PopUpWrapper';
import MobileTranslateMenuPopUp from '../popUps/MobileTranslateMenuPopUp';
import { MainAppContext } from '../../MainAppContext';
import { useIcons } from '../../utils/hooks';

function MobileMenu({
	MenuIcon,
	setRouting,
	showLanguages,
	colors,
	items,
	languages,
	support,
	translate,

	/* OPTIONAL PROPS */
	classNameBTN = 'cursor-auto py-4 pl-2 w-full',
	classNameTXT = 'float-left font-bold',
	classNameSEPARATOR = 'w-full border-t mt-2 mb-3',
}) {
	/* PopUp managment */
	const [openPopUp, setOpenPopUp] = React.useState(false);

	/* Icon hook */
	const { ArrowDown } = useIcons(colors);

	/* MAIN APP CONTEXT; PORTAL DATA; COLORS AND ROUTING */
	const { openMobileMenu, setOpenMobileMenu } = React.useContext(MainAppContext);

	/* Default values for the styles */
	const defaultStyleLIST = {
		backgroundColor: colors?.light,
	};
	const defaultStyleITEM = {
		backgroundColor: null,
		border: null,
		boxShadow: null,
	};
	const defaultStyleSEPARATOR = {
		borderBottom: `1px solid ${colors?.primary}`,
	};
	const defaultStyleSHADOW = {
		backgroundColor: `${colors?.dark}${HEX_ALPHA[90]}`,
		transition: 'all 100ms ease-in',
	};
	const defaultStyleModal = {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		backgroundColor: `${colors?.background}`,
		transition: 'all 100ms ease-in',
		zIndex: 1000,
	};

	return <React.Fragment>
		<div
			id='MobileMenu'
			className='absolute font-lato z-40 w-full top-0 -left-6 flex md:invisible'
		>
			<div className='w-full'>
				{/* BURGER BUTTON */}
				<div
					className={'float-right cursor-pointer self-end mt-8 mr-4 focus:outline-none'}
					onClick={() => setOpenMobileMenu(!openMobileMenu)}
				>
					{MenuIcon && MenuIcon({})}
				</div>
				{openMobileMenu && <Transition
					as='div'
					show={openMobileMenu}
					enter="ease-in-out duration-500"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-500"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					{/* MENU LIST */}
					<div
						className='absolute z-30 top-12 w-full mt-7 pt-7 pb-6 pl-4 pr-5'
						style={defaultStyleLIST}
					>
						{/* VARIABLE SECTIONS */}
						{
							items.map(element => (
								<React.Fragment key={element.value}>
									<SimpleButton
										tag={getText(element, translate)}
										classNameBTN={classNameBTN}
										classNameTXT={classNameTXT}
										styleBTN={defaultStyleITEM}
										fillMode={false}
										colors={colors}
										onClick={() => {
											setRouting(element.value);
											setOpenMobileMenu(false);
										}}
									/>
									<Separator
										className={classNameSEPARATOR}
										style={defaultStyleSEPARATOR}
									/>
								</React.Fragment>
							))
						}
						{/* SUPPORT */}
						<SimpleButton
							tag={getText(support, translate)}
							classNameBTN={classNameBTN}
							classNameTXT={classNameTXT}
							styleBTN={defaultStyleITEM}
							fillMode={false}
							colors={colors}
							onClick={() => window.open(support?.value, '_blank')}
						/>
						{/* LANGUAGE OPTIONS */}
						{showLanguages && <React.Fragment>
							<Separator
								className={classNameSEPARATOR}
								style={defaultStyleSEPARATOR}
							/>
							<div
								className='flex py-4 pl-2 w-full justify-between cursor-pointer'
								style={{ color: colors?.text }}
								onClick={() => {
									setOpenPopUp(true);
									setOpenMobileMenu(false);
								}}
							>
								<span className='font-bold' >
									{translate?.language ?? 'Idioma'}
								</span>
								<div className='flex space-x-1 items-center'>
									<span>
										{getText(languages
											.find(lang => lang?.value === translate.currentLanguage), translate)}
									</span>
									{ArrowDown && ArrowDown({})}
								</div>
							</div>
						</React.Fragment>}
					</div>
					{/* BLUE BACKGROUND */}
					<div
						id='MobileMenuShadow'
						className='fixed z-20 top-30 left-0 right-0 bottom-0'
						style={defaultStyleSHADOW}
						onClick={() => setOpenMobileMenu(false)}
					/>
				</Transition>}
			</div>
		</div>
		{/* CONFIRM POPUP */}
		<PopUpWrapper
			colors={colors}
			open={openPopUp}
			setOpen={setOpenPopUp}
			styleModal={defaultStyleModal}
		>
			<MobileTranslateMenuPopUp
				translate={translate}
				languages={languages}
				onClick={() => setOpenPopUp(false)}
				colors={colors}
			/>
		</PopUpWrapper>
	</React.Fragment>;
}

export default MobileMenu;
